import AvgShareOfShelfRankingByStore from "./AvgShareOfShelfRankingByStore";
export default AvgShareOfShelfRankingByStore;
